module.exports = __webpack_public_path__ + "static/media/9DESA32.3943bdcc.jpg";